import http from '@/common/request/axios';

export const collectionService = {
    get(collectionId: number) {
        return http.doGet('admin/collection/' + collectionId);
    },

    list({ type }: any) {
        return http.doGet('admin/collection', { type });
    },

    remove(collectionId: number) {
        return http.doDelete('admin/collection/' + collectionId);
    },

    publish(collectionId: number) {
        return http.doPut('admin/collection/' + collectionId + '/publish');
    },

    unpublish(collectionId: number) {
        return http.doPut('admin/collection/' + collectionId + '/unpublish');
    },

    create(name: string, type: number, coverColor: string, image: any) {
        return http.doPost('admin/collection', { name, type, coverColor }, { image });
    },

    update(collectionId: number, name: string, type: number, coverColor: string, image: any) {
        return http.doPut('admin/collection/' + collectionId, { name, type, coverColor }, { image });
    },

    getText(collectionId: any, locale: any) {
        return http.doGet('admin/collection/' + collectionId + '/text/' + locale);
    },

    updateText(collectionId: any, locale: any, title: any) {
        return http.doPut('admin/collection/' + collectionId + '/text/' + locale, { title });
    },

    removeText(collectionId: any, locale: any) {
        return http.doDelete('admin/collection/' + collectionId + '/text/' + locale);
    },

    item: {
        list({ collectionId }: any) {
            return http.doGet('admin/collection/' + collectionId + '/item');
        },
        get(collectionId: number, itemId: number) {
            return http.doGet('admin/collection/' + collectionId + '/item/' + itemId);
        },
        create(collectionId: number, assetId: number, sortOrder: number) {
            return http.doPost('admin/collection/' + collectionId + '/item', { assetId, sortOrder });
        },
        update(collectionId: number, itemId: number, assetId: number, sortOrder: number) {
            return http.doPut('admin/collection/' + collectionId + '/item/' + itemId, { assetId, sortOrder });
        },
        remove(collectionId: number, itemId: number) {
            return http.doDelete('admin/collection/' + collectionId + '/item/' + itemId);
        },

        updateGameplay(
            collectionId: number,
            itemId: number,
            pieceCount: number,
            piecePrevPercent: number,
            pieceTwoBackPercent: number,
            freeBoosterCharge: number
        ) {
            return http.doPut('admin/collection/' + collectionId + '/item/' + itemId + '/gameplay', {
                pieceCount,
                piecePrevPercent,
                pieceTwoBackPercent,
                freeBoosterCharge
            });
        }
    }
};
